import { useEventListener } from '@vueuse/core'

import type { RouteLocationNormalizedLoaded } from 'vue-router'

export default defineNuxtPlugin(() => {
  const lastRoute = ref<RouteLocationNormalizedLoaded>()

  const router = useRouter()

  // Store the last route before navigating away
  router.afterEach((_, from) => {
    lastRoute.value = from
  })

  // Cancel all ongoing API requests when refreshing the page
  useEventListener(window, 'beforeunload', () => {
    const { cancelAllRequests } = useAbortController()

    cancelAllRequests()
  })

  return {
    provide: {
      lastRoute
    }
  }
})
